module.exports = __webpack_public_path__ + "2b89e20071dd734f42b8694d7a84c264.js";